import { render, staticRenderFns } from "./searchSku.vue?vue&type=template&id=70b4bcf1"
import script from "./searchSku.vue?vue&type=script&lang=js"
export * from "./searchSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports